import { Inbox, Search } from 'lucide-react';
import Link from 'next/link';

interface EmptyStateProps {
  icon?: 'inbox' | 'search';
  title: string;
  description: string;
  actionLabel?: string;
  actionHref?: string;
}

export function EmptyState({
  icon = 'inbox',
  title,
  description,
  actionLabel,
  actionHref,
}: EmptyStateProps) {
  const Icon = icon === 'search' ? Search : Inbox;

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center rounded-xl border border-[#D4AF37]/10 bg-gradient-to-br from-black/60 to-black/40 p-12 text-center backdrop-blur-md">
      <Icon className="mb-6 h-16 w-16 text-[#D4AF37]/30" />
      <h3 className="mb-3 font-serif text-2xl font-bold text-white">{title}</h3>
      <p className="mb-8 max-w-md text-gray-400">{description}</p>
      {actionLabel && actionHref && (
        <Link
          href={actionHref}
          className="rounded-lg bg-gradient-to-r from-[#D4AF37] to-[#B76E79] px-8 py-3 font-semibold text-black transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(212,175,55,0.5)]"
        >
          {actionLabel}
        </Link>
      )}
    </div>
  );
}
